/*
 * @Author: 符应飞
 * @Date: 2021-08-18 13:57:56
 * @LastEditors: 符应飞
 * @LastEditTime: 2025-08-14 09:17:06
 * @FilePath: \verify-baidu\src\store\index.js
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {reqLogin,reqAddFace,reqUserInfo, reqExistFace } from "@/api/verify"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('faceToken')?localStorage.getItem('faceToken') : '',
    userId: window.localStorage.getItem('userId')?window.localStorage.getItem('userId') : '',
    lastTenantID: window.localStorage.getItem('lastTenantID')? window.localStorage.getItem('lastTenantID') : '',
    userInfo:window.localStorage.getItem('userInfo')? JSON.parse(window.localStorage.getItem('userInfo')) : '',
    groupId:'1',
    faceInfo: '',
    device:'',
    importStatus: window.localStorage.getItem('importStatus')? window.localStorage.getItem('importStatus') : 1,//录入状态 1未录入 2已录入
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_FACEINFO: (state, faceInfo) => {
      state.faceInfo = faceInfo
    },
    SET_DEVICE: (state, device) => {
      state.device = device
    },
    SET_TENENTID: (state, lastTenantID) => {
      state.lastTenantID = lastTenantID
    },
    SET_ImportStatus: (state, payload) => {
      state.importStatus = payload
      window.localStorage.setItem('importStatus', payload)
    },
    REMOVE_TOKEN: (state) => {
      state.token = ''
    },
  },
  actions: {
    // remove token
    resetToken({ commit }) {
      return new Promise(resolve => {
        removeToken() // must remove  token  first
        commit('SET_USERID','');
        window.localStorage.removeItem('userId')
        resolve();
      })
    },
    login({commit},loginForm) {
      return new Promise((resolve,reject) => {
        reqLogin(loginForm).then(response => {
          if(response.code !=0) {
            reject(response)
            return;
          }
          console.log('response',response)
          let { token, userId, userInfo} = response.tokenEntity

          commit('SET_TOKEN',token)
          commit('SET_USERID', userId)
          commit('SET_USERINFO',userInfo[0])
          window.localStorage.setItem('userInfo', JSON.stringify(userInfo[0]));
          window.localStorage.setItem('userId', userId);
          window.localStorage.setItem('faceToken', token);
          setToken(token)
          resolve(token);
  
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getUserFace({commit}, token) {
        return new Promise((resolve, reject) => {
            reqExistFace({
                token
            }).then(res => {
                if(res.code ==0 ) {
                  let faceInfo = res.exist==true? res.faceImg : '';
                  commit('SET_FACEINFO',faceInfo);
                } 
                resolve();
            }).catch(() => {
                reject()
            })
        })
    }
  }
})
